import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import type { BlockViewProps } from '@plone/types';
import { flattenToAppURL } from '@plone/volto/helpers';
import { View as FormView } from 'volto-form-block';
import { clearCart, getCartTypeFromPathname } from '../../cart/cart';

type FormState = {
  submitForm?: {
    subrequests?: Record<string, { loaded?: boolean }>;
  };
};

type FormBlockData = BlockViewProps['data'] & {
  subblocks?: Array<{ field_type?: string }>;
  redirect_target?: Array<{ '@id'?: string; title?: string }>;
};

const CartAwareFormView = (props: BlockViewProps) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const cartType = getCartTypeFromPathname(pathname);
  const data = props.data as FormBlockData;
  const hasCartField = data.subblocks?.some(
    (field) => field.field_type === 'cart',
  );
  const redirectTarget = data.redirect_target?.[0]?.['@id'];
  const submissionLoaded = useSelector<FormState, boolean>((state) =>
    Boolean(state.submitForm?.subrequests?.[props.id]?.loaded),
  );
  const previousSubmissionLoaded = useRef(submissionLoaded);

  useEffect(() => {
    if (submissionLoaded && !previousSubmissionLoaded.current) {
      if (hasCartField && cartType) {
        clearCart(cartType);
      }

      if (redirectTarget) {
        history.push(flattenToAppURL(redirectTarget));
      }
    }

    previousSubmissionLoaded.current = submissionLoaded;
  }, [cartType, hasCartField, history, redirectTarget, submissionLoaded]);

  return (
    <div className={`block form ${props.className || ''}`} style={props.style}>
      <FormView {...props} />
    </div>
  );
};

export default CartAwareFormView;
